/**
 * @file App constants — formStages.ts.
 */

// src/constants/formStages.ts
// ✅ Central place to store all stage codes (can expand later)

export const FORM_STAGE_CODES = {
  CONTRIBUTOR_DETAILS: "CONTRIBUTOR_DETAILS",
  PUBLICATION_DETAILS: "PUBLICATION_DETAILS",
  BACKGROUND_DATA: "BACKGROUND_DATA",
  A1_RAW_MATERIAL_SUPPLY: "RAW_MATERIAL_EXTRACTION_A1",
  A2_RAW_MATERIAL_TRANSPORT: "RAW_MATERIAL_TRANSPORT_A2",
  A3_RAW_MATERIAL_MANUFACTURING: "RAW_MATERIAL_MANUFACTURING_A3",
  // Add more stages like A1, A2, etc. later
} as const;

/** Type definition — Form Stage Code. */
export type FormStageCode = keyof typeof FORM_STAGE_CODES;
